import styled from '@emotion/styled';
import { Box } from '@kc-console/common-ui';

import { MediaQuery } from '../../constants';

import type { PropsWithChildren } from 'react';

/**
 * 전체 화면 에러 레이아웃 컴포넌트
 *
 * @description
 * 전체 화면을 차지하는 에러 컴포넌트를 위한 레이아웃입니다.
 * 중앙 정렬된 컨테이너로 자식 요소들을 배치하며, 반응형 처리를 포함합니다.
 *
 * @example
 * ```tsx
 * <FullPageErrorLayout>
 *   <ServiceMaintenance />
 * </FullPageErrorLayout>
 * ```
 */
export const FullPageErrorLayout = ({ children }: PropsWithChildren) => {
  return <LayoutContainer>{children}</LayoutContainer>;
};

const LayoutContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  min-height: 800px;
  padding: 20px;

  ${MediaQuery.TIL_SMALL} {
    padding: 16px;
    min-height: 600px;
  }
`;
